import { LandingLayout } from '@/components/landing/LandingLayout';
import { Helmet } from 'react-helmet-async';

const Terms = () => {
  return (
    <>
      <Helmet>
        <title>Terms of Service - Rental Manager</title>
        <meta name="description" content="Terms of service for Rental Manager property management platform." />
      </Helmet>

      <LandingLayout>
        <section className="py-16 container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl font-bold mb-8">Terms of Service</h1>
          
          <div className="prose prose-slate max-w-none space-y-6">
            <p className="text-muted-foreground">
              Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
            </p>

            <h2 className="text-2xl font-bold mt-8">Acceptance of Terms</h2>
            <p className="text-muted-foreground">
              By using Rental Manager, you agree to these terms of service.
            </p>

            <h2 className="text-2xl font-bold mt-8">Service Description</h2>
            <p className="text-muted-foreground">
              Rental Manager provides turnover coordination and cleaner scheduling software for 
              short-term rental hosts with 1–50 active listings. We help you manage cleanings, 
              prevent double bookings, coordinate back-to-back turnovers, and track booking schedules. 
              This is NOT an enterprise property management system — it's built specifically for 
              small Airbnb hosts and vacation rental operators.
            </p>

            <h2 className="text-2xl font-bold mt-8">What We Do (and Don't Do)</h2>
            <p className="text-muted-foreground">
              We provide: Shared turnover calendar for hosts and cleaners. Automatic cleaning reminders. 
              Booking schedules and cleaner assignments. Payout tracking (who cleaned what). Free hands-on 
              setup for 1 listing (~10 minutes).
            </p>
            <p className="text-muted-foreground mt-4">
              We do NOT: Process payments on behalf of landlords or cleaners. Provide payment gateway 
              or escrow services. Handle tenant screening, background checks, or legal compliance. 
              Offer guaranteed profitability or financial advice. We provide tracking and coordination 
              tools only — not financial services.
            </p>

            <h2 className="text-2xl font-bold mt-8">User Responsibilities</h2>
            <p className="text-muted-foreground">
              You are responsible for: Maintaining accurate property and booking information. Complying 
              with local rental laws and short-term rental regulations. Ensuring cleaners have proper 
              access and instructions. Keeping your account secure and not sharing credentials. Paying 
              cleaners directly (we only track payouts, we don't process payments).
            </p>

            <h2 className="text-2xl font-bold mt-8">Limitations of Liability</h2>
            <p className="text-muted-foreground">
              Rental Manager is a coordination tool, not a property manager. We are not responsible 
              for: Missed cleanings or late turnovers. Guest complaints or property damage. Disputes 
              between hosts and cleaners. Loss of rental income due to scheduling issues. Compliance 
              with local STR regulations. You use this software at your own risk to coordinate your 
              own operations.
            </p>

            <h2 className="text-2xl font-bold mt-8">No Guarantees</h2>
            <p className="text-muted-foreground">
              We do not guarantee: Profitability or occupancy rates. Prevention of all double bookings 
              (you must configure your calendar correctly). That cleaners will show up on time (we send 
              reminders, but cleaners are your responsibility). Compliance with any specific regulations.
            </p>

            <h2 className="text-2xl font-bold mt-8">Termination</h2>
            <p className="text-muted-foreground">
              You may terminate your account at any time. We reserve the right to 
              suspend accounts for violations of these terms.
            </p>

            <h2 className="text-2xl font-bold mt-8">Contact & Company Information</h2>
            <p className="text-muted-foreground">
              <strong>Service operated by:</strong> Shift Box Solutions UG<br />
              <strong>Data hosting:</strong> EU (Frankfurt, Germany)<br />
              <strong>Legal inquiries:</strong> support@rental.shift-box.com<br />
              <strong>General Support:</strong> support@rental.shift-box.com
            </p>
            <p className="text-muted-foreground mt-4">
              ⚠️ <strong>Important:</strong> Geographic restrictions may apply. All data is hosted in EU data centers. 
              Contact support@rental.shift-box.com for questions.
            </p>
          </div>
        </section>
      </LandingLayout>
    </>
  );
};

export default Terms;
